import React, {useState} from "react";
import CreateTagModal from "../../edit-menu/components/CreateTagModal";
import {ListBlock} from "./ListBlock";
import {SideItemRow} from "./SideItemRow";

export const TagsBlock = ({project, onUpdateProject, getUserProjects}) => {
    const [openManageModal, setOpenManageModal] = useState(false);
    const [selectedTag, setSelectedTag] = useState(null);
    const [search, setSearch] = useState("");

    const onUpdateTag = async (tag) => {
        const newProject = {...project};
        if (!newProject.settings) newProject.settings = {};
        if (!newProject.settings.tags) newProject.settings.tags = [];

        const tagIndex = newProject.settings.tags.findIndex((t) => t.id === tag.id);
        if (tagIndex >= 0) {
            newProject.settings.tags[tagIndex] = tag;
        } else {
            newProject.settings.tags.push(tag);
        }

        await onUpdateProject(newProject);
        await getUserProjects();
    };

    const onRemove = async (id) => {
        const newProject = {...project};
        newProject.settings.tags = newProject?.settings?.tags?.filter((item) => item.id !== id) || [];
        await onUpdateProject(newProject);
        await getUserProjects();
    };

    const items = project?.settings?.tags?.filter(
        (item) => item?.name?.toLowerCase()?.includes(search?.toLowerCase()),
    ) || [];

    return (
        <>
            <CreateTagModal
                open={openManageModal}
                handleClose={() => {
                    setOpenManageModal(false);
                    setSelectedTag(null);
                }}
                tag={selectedTag}
                handleSubmit={onUpdateTag}
                onRemove={onRemove}
                project={project}
            />
            <ListBlock
                title="Tags"
                items={items}
                search={search}
                onChangeSearch={setSearch}
                onCreate={() => setOpenManageModal(true)}
                mapItem={(tag) => (
                    <SideItemRow
                        key={tag?.id}
                        label={tag?.name}
                        tooltip={tag?.name}
                        onClick={() => {
                            setSelectedTag(tag);
                            setOpenManageModal(true);
                        }}
                    />
                )}
            />
        </>
    );
};
